module.exports = __webpack_public_path__ + "img/offline.2ab9c1c5.png";